document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cls-switcher').forEach(function (switcher) {
    var trigger  = switcher.querySelector('.cls-trigger');
    var dropdown = switcher.querySelector('.cls-dropdown');

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      // Închide toate celelalte dropdown-uri deschise
      document.querySelectorAll('.cls-switcher').forEach(function (other) {
        if (other !== switcher) {
          other.querySelector('.cls-trigger').setAttribute('aria-expanded', 'false');
          other.querySelector('.cls-dropdown').hidden = true;
        }
      });

      trigger.setAttribute('aria-expanded', String(!isOpen));
      dropdown.hidden = isOpen;
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.cls-switcher').forEach(function (switcher) {
      switcher.querySelector('.cls-trigger').setAttribute('aria-expanded', 'false');
      switcher.querySelector('.cls-dropdown').hidden = true;
    });
  });
});